/* The words a shopper has put on the product (a gift tag, say). Loaded only when the
   chosen way to buy offers the field. The field's own maxlength already caps the
   length; this keeps what is typed to English letters and spaces, the only thing the
   people who write the tag can be sure to reproduce, and shows how many are left.
   Without this file the field still works and still stops at its limit. */
(function () {
  document.querySelectorAll('[data-val-personal]').forEach(function (field) {
    var input = field.querySelector('input');
    var count = field.querySelector('[data-val-personal-count]');
    if (!input) return;

    var max = parseInt(input.getAttribute('maxlength'), 10) || 0;

    var tidy = function () {
      var clean = input.value.replace(/[^A-Za-z ]/g, '').replace(/^ +/, '').replace(/ {2,}/g, ' ');
      if (max) clean = clean.slice(0, max);
      if (clean !== input.value) input.value = clean;
      if (count) count.textContent = clean.length;
    };

    input.addEventListener('input', tidy);
    // A trailing space would reach the order as part of the name.
    input.addEventListener('blur', function () {
      input.value = input.value.replace(/ +$/, '');
      tidy();
    });
    tidy();
  });
})();
